
import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingOverlayProps {
  message?: string;
  isVisible: boolean;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ message = 'Loading...', isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="absolute inset-0 z-[60] bg-white/80 dark:bg-slate-950/80 backdrop-blur-sm flex flex-col items-center justify-center animate-in fade-in duration-200">
       <Loader2 className="h-10 w-10 text-teal-600 animate-spin mb-4" />
       <p className="text-sm font-bold text-slate-700 dark:text-slate-200">{message}</p>
    </div>
  );
};
